import { FormaAplicacaoValorEnum } from "core/features/grupo-desconto/typings";

export function getAplicarDescontoDiaOptions() {
  return [
    {
      label: "Antes do vencimento",
      value: '1',
    },
    {
      label: "Até o dia do vencimento",
      value: '0',
    },
  ];
}

export function getFormaDescontoOptions() {
  return [
    {
      label: "Valor fixo",
      value: FormaAplicacaoValorEnum.ValorFixo,
    },
    {
      label: "Porcentagem",
      value: FormaAplicacaoValorEnum.Porcentagem,
    },
  ];
}

export function getContaCategoriaQuantidadeOptions() {
  return [
    {
      label: "Todas as contas categorias",
      value: '1',
    },
    {
      label: "Algumas contas categorias",
      value: '0',
    },
  ];
}